import { lazy } from 'react';

const CircularityAvailableConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/circularity/available',
			component: lazy(() => import('./CircularityAvailableContainer'))
		}
	]
};

export default CircularityAvailableConfig;
